import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const telnyx = defineConnector({
  identifier: "telnyx",
  name: "Telnyx",
  tagLine: "Voice, SMS, and connectivity APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.telnyx\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Telnyx portal](https://portal.telnyx.com/), open **Account settings › Keys & Credentials** and create an API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "KEY...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.telnyx.com/v2/phone_numbers",
  },
});
